import React, { forwardRef } from 'react';
import CardMC from '../../../components/CardMC';
import InputMC from '../../../components/InputMC';
import InputWithVariablesMC from '../../../components/InputWithVariablesMC';
import ButtonMC from '../../../components/ButtonMC';
import IconMC from '../../../components/IconMC';

const WebhookHeaderEditor = forwardRef(({
  t,
  headerFields,
  removeHeader,
  availableColumns,
  appendHeader
}, ref) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <h3 className="tw-text-sm tw-font-semibold tw-text-gray-950 tw-mb-0">
          {t('webhook_header_title')}
        </h3>
        <p className="tw-text-xs tw-text-gray-700 tw-mb-0">
          {t('header_editor_description')}
        </p>
      </div>

      <div className="tw-flex tw-flex-col tw-gap-4">
        {headerFields.map((field, index) => (
          <CardMC key={field.id} className="tw-p-4 tw-flex tw-flex-col tw-gap-3 tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl">
            <div className="tw-flex tw-justify-between tw-items-center">
              <span className="tw-text-xs tw-font-semibold tw-text-gray-700 uppercase">
                {t('header_item_title', { index: index + 1 })}
              </span>
              <button
                type="button"
                onClick={() => removeHeader(index)}
                className="tw-text-gray-400 hover:tw-text-red-500"
              >
                <IconMC name="trash-2-outline" size="base" />
              </button>
            </div>
            <div className="tw-flex tw-gap-3">
              <div className="tw-flex-1">
                <InputMC
                  name={`headers.${index}.key`}
                  label={t('header_name_label')}
                  placeholder={t('header_name_placeholder')}
                  useFloatingLabel
                />
              </div>
              <div className="tw-flex-[2]">
                <InputWithVariablesMC
                  name={`headers.${index}.value`}
                  label={t('header_value_label')}
                  placeholder={t('header_value_placeholder')}
                  useFloatingLabel
                  options={availableColumns}
                  propertyListTitle={t('property_list.title')}
                  propertyListPlaceholder={t('search_placeholder')}
                  propertyListNoResults={t('property_list.no_results_message')}
                  ref={(r) => {
                    ref.current[index] = r;
                  }}
                />
              </div>
            </div>
            <div className="tw-flex tw-justify-between tw-items-center">
              <span className="tw-text-[10px] tw-text-gray-500">
                {t('insert_variables_hint')}
              </span>
              <ButtonMC
                text={t('add_variable_button')}
                variant="SECONDARY"
                outlined
                className="tw-w-fit"
                size="xs"
                onClick={() => ref.current[index]?.triggerPropertyList()}
              />
            </div>
          </CardMC>
        ))}

        <ButtonMC
          text={t('add_header_button')}
          variant="SECONDARY"
          outlined
          className="tw-w-full tw-py-2"
          onClick={() => appendHeader({ key: '', value: '' })}
        />
      </div>
    </div>
  );
});

export default WebhookHeaderEditor;
